export default "__VITE_ASSET__Di385uDX__"